"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMotion = void 0;
function getMotion(_a) {
    var prefixCls = _a.prefixCls, motion = _a.motion, animation = _a.animation, transitionName = _a.transitionName;
    if (motion) {
        return motion;
    }
    if (animation) {
        return {
            motionName: "".concat(prefixCls, "-").concat(animation),
        };
    }
    if (transitionName) {
        return {
            motionName: transitionName,
        };
    }
    return null;
}
exports.getMotion = getMotion;
//# sourceMappingURL=legacyUtil.js.map